export default __webpack_public_path__ + "dbfc9bd38069b6486bf5a060cfc81a16.svg";